// use-resources-dialog.component.ts
import { Component, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { MatIconModule } from '@angular/material/icon';
import { CommonModule } from '@angular/common';
import { MatDialogModule } from '@angular/material/dialog';

@Component({
  selector: 'app-use-resources-dialog',
  standalone: true,
  templateUrl: './use-resources-dialog.component.html',
  styleUrls: ['./use-resources-dialog.component.css'],
  imports: [CommonModule, MatDialogModule, MatIconModule],
})
export class UseResourcesDialogComponent {
  constructor(
    public dialogRef: MatDialogRef<UseResourcesDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: { make: string; model: string }
  ) {}

  onYes(): void {
    this.dialogRef.close(true);
  }

  onNo(): void {
    this.dialogRef.close(false);
  }
   cancel(): void {
    this.dialogRef.close(null);
  }

}
